import {
	comMapping
} from '../../../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		formList1: [
			{
				prop: "fangcbh",
				label: "房产编号",
				isnotnull: true,
				type: "input",
			},
			{
				prop: "fangcmc",
				label: "房产名称",
				type: "input",
			},
			{
				prop: "fangcyt",
				label: "房屋用途",
				isnotnull: true,
				type: "select",
			},
			{
				prop: "fangcqdsj",
				label: "房产取得时间",
				isnotnull: true,
				type: "date",
				isdate: true,
				valueformat: "yyyy-MM-dd",
			},
			{
				prop: "jianzmj",
				label: "建筑面积",
				isnotnull: true,
				type: "input",
			},
			{
				prop: "nsrlx",
				label: "纳税人类型",
				isnotnull: true,
				type: "select",
			},
			{
				prop: "suoyqNsrsbh",
				label: "所有权人纳税人识别号 (统一社会信用代码)",
				type: "input",
			},
			{
				prop: "suoyqMc",
				label: "所有权名称",
				type: "input",
			},
			{
				prop: "cqzhlx",
				label: "产权证号类型",
				type: "select",
			},
			{
				prop: "budcdydm",
				label: "不动产单位代码",
				type: "input",
			},
			{
				prop: "budcqzh",
				label: "不动产权证号",
				type: "input",
			},
			{
				prop: "fangwsztdbh",
				label: "房屋所在土地编号",
				type: "input",
			}
		],
		formList2: [
			{
				prop: "fangwzldzXian",
				label: "",
				slot: true,
				type: "select",
			},
			{
				prop: "fangwzldzXiangz",
				label: "房屋坐落地址(所处街乡)",
				type: "select",
				isnotnull: true,
				selectval: []
			},
			{
				prop: "fangwzldzXx",
				label: "房屋坐落详细地址",
				isnotnull: true,
				type: "input",
			},
			{
				prop: "fangczgsws",
				label: "房屋所属税务所(科，分局)",
				isnotnull: true,
				type: "input",
			}
		],
		formList3: [
			{
				prop: "fangcyz",
				label: "房产原值",
				type: "input",
				isnotnull: true,
			},
			{
				prop: "chuzfcyz",
				label: "出租房产原值",
				type: "input",
				isnotnull: true,
			},
			{
				prop: "chuzfcmj",
				label: "出租面积",
				isnotnull: true,
				type: "input",
			},
			{
				prop: "jisbl",
				label: "计税比例",
				isnotnull: true,
				type: "input",
			}
		],
		formList4: [
			{
				prop: "czchuzfcmj",
				label: "从租出租面积",
				isnotnull: true,
				type: "input",
			},
			{
				prop: "chengzNsrsbh",
				label: "承租方纳税人识别号",
				type: "input",
			},
			{
				prop: "zulqq",
				label: "申报期起",
				type: "date",
				isdate: true,
				isnotnull: true,
				valueformat: 'yyyy-MM-dd',
			},
			{
				prop: "chengzMc",
				label: "承租方名称",
				type: "input",
			},
			{
				prop: "shenbzjsr",
				label: "申报租金收入",
				isnotnull: true,
				type: "input",
			},
			{
				prop: "zulqz",
				label: "申报期止",
				type: "date",
				isdate: true,
				isnotnull: true,
				valueformat: 'yyyy-MM-dd',
			}
		],
		formList5: [
			{
				prop: "congjpkbz",
				label: "从价批扣标志",
				type: "select",
				selectval: [{
					value: '0',
					label: '是',
				}, {
					value: '1',
					label: '否',
				}]
			},
			{
				prop: "dailrysfzlx",
				label: "代理人员身份证件类型",
				type: "select",
				selectval: comMapping.$cztds,
			},
			{
				prop: "dailrmc",
				label: "代理人名称",
				type: "input",
			},
			{
				prop: "shoulrq",
				label: "受理日期",
				type: "date",
				isdate: true,
				valueformat: "yyyy-MM-dd",
			},
			{
				prop: "nsywYxqq",
				label: "纳税义务有效期起",
				type: "date",
				isdate: true,
				isnotnull: true,
				valueformat: "yyyy-MM-dd",
			},
			{
				prop: "congzpkbz",
				label: "从租批扣标志",
				type: "select",
				selectval: [{
					value: '0',
					label: '是',
				}, {
					value: '1',
					label: '否',
				}]
			},
			{
				prop: "dailrsfzhm",
				label: "代理人身份证件号码",
				type: "input",
			},
			{
				prop: "shoulr",
				label: "受理人",
				type: "input",
			},
			{
				prop: "shoulswjg",
				label: "受理税务机关",
				type: "input",
			},
			{
				prop: "nsywYxqz",
				label: "纳税义务有效期止",
				type: "date",
				isdate: true,
				isnotnull: true,
				valueformat: "yyyy-MM-dd",
			},
			{
				prop: "bgsj",
				label: "变更时间",
				isnotnull: true,
				type: "date",
				isdate: true,
				valueformat: "yyyy-MM-dd",
			}
		],
		formdata: {
			bgsj: "",
			jisbl: '',
			chuzfcyz: '',
			nsywYxqz: '',
			nsywYxqq: '',
			cqzhlx: '',
			bdcdwdm: '',
			fangcyz: '',
			congjpkbz: '',
			congzpkbz: '',
			dailrysfzlx: '',
			dailrsfzhm: '',
			dailrmc: '',
			shoulr: '',
			shoulrq: '',
			shoulswjg: '',
			fangcbh: '',
			fangwsztdbh: '',
			fangcmc: '',
			budcqzh: '',
			nsrlx: '',
			fangcyt: '',
			suoyqNsrsbh: '',
			suoyqMc: '',
			fangwzldzXian: '',
			fangwzldzXiangz: '',
			fangwzldzXx: '',
			fangczgsws: '',
			fangcqdsj: '',
			jianzmj: '',
			czchuzfcmj: "",
			chengzMc: "",
			chengzNsrsbh: "",
			shenbzjsr: "",
			zulqq: "",
			zulqz: "",
		},
		headData: [{
				title: "选择",
				prop: "choose",
				width: "50",
				custom: true
			},
			{
				title: "房产编号",
				prop: "fangcbh",
				width: "80",
				custom: true
			}, {
				title: "纳税义务有效期起",
				prop: "nsywYxqq",
				width: "120",
			}, {
				title: "纳税义务有效期止",
				prop: "nsywYxqz",
				width: "120",
			},
			{
				title: "房屋所在土地编号",
				prop: "fangwsztdbh",
				width: "120"
			},
			{
				title: "房产名称",
				prop: "fangcmc",
				width: 160,
				align: "left"
			},
			{
				title: "不动产权证号",
				prop: "budcqzh",
				width: 160,
				align: "left"
			},
			{
				title: "建筑面积",
				prop: "jianzmj",
				width: 80,
				AmountFormat: true,
				align: "right"
			}, {
				title: "状态",
				prop: "caijFlag",
				width: "120",
				custom: true,
				align: "right"
			},
			{
				title: "操作",
				prop: "cz",
				width: "120",
				custom: true,
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}